var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-main"},[_c('p',{staticClass:"mb-0"},[_vm._v("© ITFA - "+_vm._s(_vm.$t('allRightsReserved')))]),_c('b-button',{attrs:{"id":"btnToTop"},on:{"click":_vm.toTop}},[_c('img',{attrs:{"src":require("../../assets/images/up-arrow.png"),"alt":"Boton arriba"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }